import { render, staticRenderFns } from "./DiskSpaceAlert.vue?vue&type=template&id=d0641168&scoped=true"
import script from "./DiskSpaceAlert.vue?vue&type=script&lang=js"
export * from "./DiskSpaceAlert.vue?vue&type=script&lang=js"
import style0 from "./DiskSpaceAlert.vue?vue&type=style&index=0&id=d0641168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0641168",
  null
  
)

export default component.exports